import React from "react";
import { connect } from "react-redux";
import { hot } from "react-hot-loader";
import {
    selectModalOpen,
    selectJobModalData,
    selectJobReportModalData,
    selectSpeUsers,
    getRequesting
} from "./selectors";
import { StyledContent } from "../../styles";
import {
    setModalOpen,
    postUpdatedStatus,
    setSnackbarOpen,
    moveJobPack,
    getRegisteredUsers
} from "./actions";
import {
    Button,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
    Typography
} from "@material-ui/core";
import warningIcon from "./imgs/Warning_icon.png";

import {
    Modal,
    ModalHeader,
    ModalFooter,
    ModalBody,
    Spinner
} from "reactstrap";
let modalMonth = ""
let modalYear = ""
const ModalInfoText = props => {
    return (
        <Typography variant="subheading" style={{ marginBottom: 15 }}>
            {props.text}
        </Typography>
    );
};

class JobPackModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            status: props.jobData.status || "active"
        };
        this.props.getRegisteredUsers();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.jobData !== this.props.jobData) {
            this.setState({
                status: this.props.jobData.status || "active"
            });
        }
    }
    render() {
        const {
            modalOpen,
            jobData,
            reportData,
            users,
            // year,
            // month
        } = this.props;
        if (typeof jobData.timestamp !== "undefined") {
            let monthref = jobData.timestamp.split("-")
            let conditionCheck = monthref[1]
            if (conditionCheck === "01") { modalMonth = "jan" }
            else if (conditionCheck === "02") { modalMonth = "feb" }
            else if (conditionCheck === "03") { modalMonth = "mar" }
            else if (conditionCheck === "04") { modalMonth = "apr" }
            else if (conditionCheck === "05") { modalMonth = "may" }
            else if (conditionCheck === "06") { modalMonth = "jun" }
            else if (conditionCheck === "07") { modalMonth = "jul" }
            else if (conditionCheck === "08") { modalMonth = "aug" }
            else if (conditionCheck === "09") { modalMonth = "sep" }
            else if (conditionCheck === "10") { modalMonth = "oct" }
            else if (conditionCheck === "11") { modalMonth = "nov" }
            else { modalMonth = "dec" }
            let conditionCheckYear = monthref[2]
            modalYear = conditionCheckYear.substring(0, 4)
        }
        return (
            <>
                <StyledContent style={{ paddingTop: "0px" }}>
                    <Modal
                        isOpen={this.props.requesting}
                        style={{ maxWidth: "00px" }}
                    >
                        <ModalBody>
                            <div
                                style={{
                                    textAlign: "center",
                                    paddingTop: "3em"
                                }}
                            >
                                <div
                                    style={{
                                        background: "white",
                                        width: "fit-content",
                                        display: "inline-block",
                                        padding: "2em"
                                    }}
                                >
                                    <Spinner
                                        style={{
                                            height: 100,
                                            width: 100,
                                            background: "white"
                                        }}
                                        color="primary"
                                    />
                                    <Typography
                                        style={{
                                            textAlign: "center",
                                            marginTop: 15,
                                            color: "rgba(0, 0, 0, 0.87)",
                                            fontWeight: "bolder",
                                            fontSize: 20
                                        }}
                                        variant="body2"
                                    >
                                        Processing...
                                    </Typography>
                                </div>
                            </div>
                        </ModalBody>
                    </Modal>
                </StyledContent>
                <Modal isOpen={modalOpen}>
                    <ModalHeader
                        style={{
                            color: "red",
                            textAlign: "center",
                            display: "inline-block"
                        }}
                    >
                        WARNING!
                    </ModalHeader>
                    <ModalHeader style={{ color: "red", fontSize: "15px" }}>
                        <p style={{ fontSize: "15px" }}>
                            <img
                                alt="warningicon"
                                src={warningIcon}
                                style={{ float: "left", height: 50, width: 50 }}
                            />
                            Please Ensure no one is adding Reports to this
                            Jobpack currently
                        </p>
                    </ModalHeader>
                    <ModalHeader style={{ color: "red" }}>
                        <p style={{ fontSize: "15px" }}>
                            <img
                                alt="warningicon"
                                src={warningIcon}
                                style={{ float: "left", height: 50, width: 50 }}
                            />
                            Please ensure that all Jobpacks
                            Active/Pending/Archived movement is done outside of
                            the work hours as this may impact your system
                        </p>
                    </ModalHeader>
                    <ModalBody>
                        <ModalInfoText text=" Update status of Jobpack" />
                        <ModalInfoText
                            text={
                                <p>
                                    Job ID: <b>{jobData.job_id}</b>
                                </p>
                            }
                        />
                        <ModalInfoText
                            text={
                                <p>
                                    Jobpack Name: <b>{jobData.job_name}</b>
                                </p>
                            }
                        />
                        <FormControl>
                            <InputLabel>Select Jobpack Status </InputLabel>

                            <Select
                                style={{ minWidth: 200 }}
                                value={this.state.status}
                                onChange={event => {
                                    this.setState({
                                        status: event.target.value
                                    });
                                }}
                            >
                                <MenuItem value="active">Active</MenuItem>
                                <MenuItem value="pending">Pending</MenuItem>
                                <MenuItem value="archived">Archive</MenuItem>
                            </Select>
                        </FormControl>
                    </ModalBody>
                    <ModalFooter>
                        <Button
                            onClick={() => {
                                this.props.setModalOpen(false);
                            }}
                            variant="contained"
                        >
                            Cancel
                        </Button>
                        <Button
                            onClick={() => {
                                this.props.setModalOpen(false);
                                this.props.moveJobPack(
                                    jobData.job_id,
                                    this.state.status,
                                    jobData,
                                    reportData,
                                    users,
                                    modalYear,
                                    modalMonth,
                                    status => {
                                        this.props.setSnackbarOpen(
                                            true,
                                            status
                                        );
                                    }
                                );
                            }}
                            disabled={this.props.requesting}
                            color="primary"
                            variant="contained"
                        >
                            Update
                        </Button>
                    </ModalFooter>
                </Modal>
            </>
        );
    }
}

export default hot(module)(
    connect(
        store => {
            return {
                modalOpen: selectModalOpen(store),
                jobData: selectJobModalData(store),
                reportData: selectJobReportModalData(store),
                users: selectSpeUsers(store),
                requesting: getRequesting(store)
            };
        },
        {
            setModalOpen,
            postUpdatedStatus,
            setSnackbarOpen,
            moveJobPack,
            getRegisteredUsers
        }
    )(JobPackModal)
);
